import React from 'react';
import { NavLink } from 'react-router-dom';
import { Logo } from '../../assets/logo';
import { Button } from '../styles/Hero.styles';
import styled from 'styled-components';

const StyledTelLink = styled.a<{ $type?: 'primary' | 'secondary' }>`
  color: ${(props) =>
    props.$type === 'secondary' ? '#000' : '#fff'} !important;
  :hover {
    color: #253ec6 !important;
  }
`;

const StyledNavLink = styled(NavLink as any)<{
  $type?: 'primary' | 'secondary';
}>`
  color: ${(props: { $type?: 'primary' | 'secondary' }) =>
    props.$type === 'secondary' ? '#000' : '#fff'} !important;
  :hover {
    color: #253ec6 !important;
  }
`;

export interface NavbarProps {
  type?: 'primary' | 'secondary';
}

export default function Navbar({ type }: NavbarProps) {
  // ios and macos
  const ios = window.navigator.userAgent.match(/iPhone|iPad|iPod|Macintosh/);

  return (
    <div className="container">
      <nav className="navbar navbar-expand-lg navbar-light">
        <a
          className="navbar-brand"
          href="/"
          style={
            type === 'secondary' ? { color: '#253EC6' } : { color: '#fff' }
          }
        >
          <Logo />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <div className="container text-xs-center">
            <ul
              style={{
                display: 'flex',
                flexGrow: 0,
              }}
            ></ul>
            <ul className="nav navbar-nav">
              <li className="nav-item c-nav">
                <StyledNavLink
                  activeClassName="bold-nav-item"
                  className="nav-link"
                  to="/services"
                  $type="secondary"
                >
                  Home Cleaning
                </StyledNavLink>
              </li>
              <li className="nav-item c-nav">
                <StyledNavLink
                  activeClassName="bold-nav-item"
                  className="nav-link"
                  to="/moving"
                  $type="secondary"
                >
                  Moving Cleaning
                </StyledNavLink>
              </li>
              <li className="nav-item c-nav">
                <StyledTelLink
                  $type="secondary"
                  className="nav-link"
                  // open default text app
                  href={`sms:+19294974111${
                    ios ? '&' : '?'
                  }body=${"Hi, I'm interested in booking a cleaning service.".replace(
                    / /g,
                    '%20'
                  )}`}
                >
                  Text us (929) 497-4111
                </StyledTelLink>
              </li>
            </ul>

            <ul className="nav navbar-nav pull-xs-right">
              <li className="nav-item">
                <a
                  className="nav-link"
                  href={`https://dashboard.heyhomero.com?utm_source=heyhomero.com&utm_campaign=${window.location?.pathname}`}
                >
                  <Button
                    style={
                      type === 'secondary' ? { background: '#253EC6' } : {}
                    }
                    // @ts-ignore
                    hoverBackground={
                      type === 'secondary' ? '#0093ED' : '#253ec6'
                    }
                  >
                    Login
                  </Button>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}
